import * as React from 'react';
import { useTranslation } from 'react-i18next';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';

const TranslatedLoader: React.FC = () => {
	const { t } = useTranslation();

	return <BounceLoader caption={t('site.loading')} />;
};

export default TranslatedLoader;
